/**
 * cart-addons.js
 * Maneja:
 *  1. Rotación automática/manual del banner de promociones
 *  2. Interceptar "Comprar ahora" para mostrar la pantalla de add-ons antes del checkout real
 *  3. Agregar/quitar los add-ons seleccionados (sin duplicar si ya estaban en el carrito)
 *
 * Requiere:
 *  - snippets/cart-promo-banner.liquid
 *  - snippets/cart-addons-step.liquid
 *  - que el formulario del carrito conserve el id "CartDrawer-Form" (Dawn estándar)
 */

(function () {
  const PROMO_ROTATE_MS = 4000;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  // ---------- Banner de promociones ----------

  function initPromoBanner() {
    const banner = qs('[data-cart-promo-banner]');
    if (!banner) return;

    const slides = qsa('[data-promo-slide]', banner);
    if (slides.length <= 1) return;

    if (banner.dataset.promoInit) return;
    banner.dataset.promoInit = 'true';

    let current = 0;

    function showSlide(index) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      current = index;
    }

    function nextSlide() {
      showSlide((current + 1) % slides.length);
    }

    let timer = setInterval(nextSlide, PROMO_ROTATE_MS);

    const nextBtn = qs('[data-promo-next]', banner);
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        clearInterval(timer);
        nextSlide();
        timer = setInterval(nextSlide, PROMO_ROTATE_MS);
      });
    }
  }

  // ---------- Pantalla de add-ons ----------

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function isVariantInCart(cart, variantId) {
    return cart.items.some((item) => String(item.variant_id) === String(variantId));
  }

  async function addAddon(variantId) {
    // Bijou: evita duplicados — si el add-on ya está en el carrito
    // (por ejemplo porque el usuario regresó a navegar y volvió a marcar
    // la casilla), no se vuelve a agregar otra unidad.
    const cart = await fetchCart();
    if (isVariantInCart(cart, variantId)) {
      return cart;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    }).then((r) => r.json());
  }

  async function removeAddon(variantId) {
    const cart = await fetchCart();
    const line = cart.items.findIndex((item) => String(item.variant_id) === String(variantId));
    if (line === -1) return;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line + 1, quantity: 0 }),
    }).then((r) => r.json());
  }

  // Bijou: al abrir la pantalla de add-ons, refleja en las casillas si ese
  // producto ya está en el carrito (por ejemplo, si el usuario ya lo había
  // agregado en un intento anterior de pagar y regresó a navegar).
  async function syncAddonCheckboxes() {
    const step = qs('[data-cart-addons-step]');
    if (!step) return;
    const checkboxes = qsa('[data-addon-checkbox]', step);
    if (!checkboxes.length) return;
    const cart = await fetchCart();
    checkboxes.forEach((checkbox) => {
      checkbox.checked = isVariantInCart(cart, checkbox.dataset.variantId);
    });
  }

  function openAddonsStep() {
    const step = qs('[data-cart-addons-step]');
    const mainView = qs('#CartDrawer-CartItems');
    const footer = qs('.drawer__footer');
    if (!step) return;
    step.hidden = false;
    if (mainView) mainView.style.display = 'none';
    if (footer) footer.style.display = 'none';
    syncAddonCheckboxes();
  }

  function closeAddonsStep() {
    const step = qs('[data-cart-addons-step]');
    const mainView = qs('#CartDrawer-CartItems');
    const footer = qs('.drawer__footer');
    if (!step) return;
    step.hidden = true;
    if (mainView) mainView.style.display = '';
    if (footer) footer.style.display = '';
  }

  function initCheckoutIntercept() {
    document.addEventListener('submit', function (e) {
      const form = e.target.closest('#CartDrawer-Form');
      if (!form) return;

      if (form.dataset.addonsConfirmed === 'true') {
        // El usuario ya pasó por la pantalla de add-ons, dejar continuar a checkout real
        return;
      }
      e.preventDefault();
      openAddonsStep();
    });
  }

  function initAddonsInteractions() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-addons-back]')) {
        closeAddonsStep();
        return;
      }

      if (e.target.closest('[data-addons-continue]')) {
        const form = qs('#CartDrawer-Form');
        if (form) form.dataset.addonsConfirmed = 'true';
        // Bijou: en vez de reenviar el formulario (que en este tema termina
        // aterrizando en /cart antes de /checkout), navegamos directo. Los
        // add-ons ya quedaron agregados al carrito en tiempo real al marcar
        // cada casilla, así que no se pierde nada.
        window.location.href = '/checkout';
      }
    });

    document.addEventListener('change', function (e) {
      const checkbox = e.target.closest('[data-addon-checkbox]');
      if (!checkbox) return;

      const variantId = checkbox.dataset.variantId;
      checkbox.disabled = true;

      const action = checkbox.checked ? addAddon(variantId) : removeAddon(variantId);
      action.finally(() => {
        checkbox.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
    });
  }

  onReady(function () {
    initPromoBanner();
    initCheckoutIntercept();
    initAddonsInteractions();
  });

  document.addEventListener('cart:updated', initPromoBanner);
  document.addEventListener('cart:refresh', initPromoBanner);

  window.BijouCartAddons = { openAddonsStep, closeAddonsStep, initPromoBanner, syncAddonCheckboxes };
})();